// extracted by mini-css-extract-plugin
export default {"heading":"WinnersTable_heading__plmTf","picture":"WinnersTable_picture__XfwOk","container":"WinnersTable_container__K4FvM","winners":"WinnersTable_winners__0awBt"};